import { useEffect, useRef } from "react";
import { prepareInstallRedirectUrl } from "../home/utils/install";

export default function InstallRedirectPage() {
  const redirectStarted = useRef(false);

  useEffect(() => {
    // StrictMode의 effect 재실행으로 첫 이동을 복귀로 오인하지 않도록 방지함
    if (redirectStarted.current) return;
    redirectStarted.current = true;
    window.location.replace(prepareInstallRedirectUrl());
  }, []);

  return null;
}
